"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_config_1 = __importDefault(require("react-native-config"));
const react_redux_1 = require("react-redux");
const slice_1 = __importDefault(require("../../../../app-reduxs/app/slice"));
const icons_1 = require("../../../../assets/icons");
const CustomText_1 = __importDefault(require("../../../../components/text/CustomText"));
const helpler_1 = require("../../../../utils/helpler");
const scale_1 = require("../../../../utils/scale");
const IntroduceVideoEditor = (props) => {
    const { defaultSource, onChange } = props;
    const dispatch = (0, react_redux_1.useDispatch)();
    const [videoSource, setVideoSource] = (0, react_1.useState)(defaultSource);
    const [uploadProgress, setUploadProgress] = (0, react_1.useState)(0);
    const [isUploading, setUploading] = (0, react_1.useState)(false);
    const onVideoPress = () => {
        const inputElement = document.getElementById("video-file-upload");
        if (inputElement) {
            inputElement.click();
        }
    };
    const handlePickVideo = (event) => {
        const file = event.target.files?.[0];
        if (file) {
            if (file.type != 'video/mp4' && file.type != 'video/quicktime') {
                dispatch(slice_1.default.actions.setToastType(false));
                dispatch(slice_1.default.actions.showToast('自己紹介動画にはMP4,MOVタイプのファイルを指定してください。'));
                return;
            }
            const maxSize = helpler_1.isWeb ? process.env.VIDEO_MAX_SIZE : react_native_config_1.default.VIDEO_MAX_SIZE;
            const isValid = (0, helpler_1.validateFile)(file, parseInt(maxSize), 'video');
            if (!isValid)
                return;
            setUploading(true);
            const fileSize = file.size;
            let uploadedBytes = 0;
            const reader = new FileReader();
            reader.onprogress = (e) => {
                uploadedBytes = e.loaded;
                const progress = (uploadedBytes / fileSize) * 100;
                setUploadProgress(progress);
            };
            reader.onloadend = () => {
                // @ts-ignore
                const url = URL.createObjectURL(file);
                setVideoSource(url);
                onChange(url);
                setUploadProgress(0);
                setUploading(false);
            };
            reader.onerror = () => {
                setUploadProgress(0);
                setUploading(false);
            };
            reader.readAsDataURL(file);
        }
    };
    const handleRemoveVideo = () => {
        setVideoSource("");
        onChange("");
    };
    return (helpler_1.isWeb ?
        react_1.default.createElement(react_native_1.TouchableOpacity, { activeOpacity: 0.8, disabled: !!videoSource, style: styles.introduceVideo, onPress: onVideoPress },
            react_1.default.createElement("input", { type: "file", accept: "video/quicktime, video/mp4", value: "", onChange: handlePickVideo, style: { display: "none" }, id: "video-file-upload" }),
            !!videoSource ?
                react_1.default.createElement(react_native_1.View, { style: styles.videoView },
                    react_1.default.createElement("video", { width: "100%", height: '100%', controls: true, src: videoSource }),
                    react_1.default.createElement(react_native_1.TouchableOpacity, { activeOpacity: 0.8, style: styles.removeButton, onPress: handleRemoveVideo },
                        react_1.default.createElement(icons_1.IC_X, { width: (0, scale_1.scale)(20.53), height: (0, scale_1.scale)(20.53), color: '#FFF' })))
                :
                    react_1.default.createElement(react_native_1.View, { style: styles.blankVideo },
                        isUploading ?
                            react_1.default.createElement(react_native_1.View, { style: styles.progressContainer },
                                react_1.default.createElement(react_native_1.View, { style: styles.progressBar },
                                    react_1.default.createElement(react_native_1.View, { style: [styles.progress, { width: `${uploadProgress}%` }] })))
                            :
                                react_1.default.createElement(icons_1.IC_VIDEO_UPLOAD, null),
                        react_1.default.createElement(CustomText_1.default, { style: styles.uploadVideoLabel }, isUploading ? '動画をアップロード中・' : '動画をアップロード')))
        :
            react_1.default.createElement(react_native_1.View, { style: styles.introduceVideo },
                react_1.default.createElement(react_native_1.View, { style: styles.blankVideo })));
};
exports.default = IntroduceVideoEditor;
const styles = react_native_1.StyleSheet.create({
    introduceVideo: {
        position: 'relative',
        marginTop: (0, scale_1.scale)(8),
        width: "100%",
        height: (0, scale_1.scale)(193),
        overflow: 'hidden',
        borderWidth: (0, scale_1.scale)(1),
        borderColor: '#C8C8C8',
        borderRadius: (0, scale_1.scale)(3),
        backgroundColor: '#FEFEFE',
    },
    videoView: {
        width: '100%',
        height: '100%',
        backgroundColor: 'black'
    },
    blankVideo: {
        width: '100%',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center'
    },
    removeButton: {
        position: 'absolute',
        top: (0, scale_1.scale)(4),
        right: (0, scale_1.scale)(4),
        width: (0, scale_1.scale)(30),
        height: (0, scale_1.scale)(30),
        backgroundColor: '#000000CC',
        borderRadius: 999,
        justifyContent: 'center',
        alignItems: 'center'
    },
    uploadVideoLabel: {
        marginTop: (0, scale_1.scale)(4),
        fontSize: (0, scale_1.moderateScale)(14),
        lineHeight: (0, scale_1.moderateScale)(21),
        color: '#292A33'
    },
    progressContainer: {
        width: '100%',
        height: (0, scale_1.scale)(50),
        justifyContent: 'center',
        alignItems: 'center'
    },
    progressBar: {
        width: (0, scale_1.scale)(200),
        height: (0, scale_1.scale)(4),
        alignSelf: 'center',
        borderRadius: 999,
        backgroundColor: '#DCDCDC'
    },
    progress: {
        height: '100%',
        borderRadius: 999,
        backgroundColor: '#007AFF'
    }
});
